'use client'

import Image from 'next/image'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { track } from '@/lib/analytics/track'
import { paintings } from './shared'

interface SokuCtaSectionProps {
  title?: string
  description?: string
  ctaLabel?: string
}

export function SokuCtaSection({
  title = 'Ready to Put Your Marketing on Autopilot?',
  description = 'Sign up and see how Soku AI finds the drivers behind performance\u2014and turns them into a weekly operating cadence.',
  ctaLabel = 'Try It Free',
}: SokuCtaSectionProps) {
  const pathname = usePathname()

  return (
    <section className="group/cta relative overflow-hidden py-16 sm:py-20 md:py-[104px]">
      <div aria-hidden className="luminism-panel absolute inset-0">
        <Image
          src={paintings.forestSunbeams}
          alt=""
          fill
          sizes="100vw"
          className="object-cover object-center transition-transform duration-700 ease-out group-has-[a:hover]/cta:scale-105"
        />
        {/* The sunbeams blow out the middle of the frame — sink it just enough
            that the headline holds without flattening the painting. */}
        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(9,14,28,0.42)_0%,rgba(9,14,28,0.30)_55%,rgba(9,14,28,0.46)_100%)]" />
      </div>
      <div className="relative z-[3] mx-auto flex w-full max-w-6xl flex-col items-center gap-8 px-5 text-center text-white sm:px-6">
        <div className="flex flex-col items-center gap-4">
          <h2 className="max-w-3xl text-3xl leading-[1.1] !font-normal tracking-[-0.01em] text-balance [text-shadow:0_2px_18px_rgba(9,14,28,0.45)] sm:text-4xl md:text-5xl">
            {title}
          </h2>
          <p className="max-w-[720px] text-sm leading-relaxed text-white/85 [text-shadow:0_1px_10px_rgba(9,14,28,0.4)] sm:text-base">
            {description}
          </p>
        </div>
        <Link
          href="/sign-up"
          onClick={() =>
            track(
              'marketing_cta_click',
              {
                cta_text: ctaLabel,
                cta_location: 'inline',
                page_path: pathname,
              },
            )
          }
          className="bg-primary text-primary-foreground rounded-full px-6 py-3 text-sm font-semibold transition hover:opacity-90 sm:text-base"
        >
          {ctaLabel}
        </Link>
      </div>
    </section>
  )
}
